export default function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-screen-md px-6 py-16 md:py-24" data-testid="privacy-page">
      <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-accent">
        <span className="h-px w-10 bg-accent" /> Legal
      </p>
      <h1 className="mt-6 font-serif text-4xl font-bold tracking-tight md:text-5xl">Privacy Policy</h1>
      <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="prose-sm mt-10 space-y-8 text-sm leading-relaxed text-foreground/85 md:text-base">
        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">What we don't store</h2>
          <p className="mt-3">
            Eunoia does not record, store, or keep any record of your therapy sessions — no chat
            transcripts, no call recordings, no session notes, no history. What you discuss with your
            therapist stays between you and them.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">What we do collect</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>
              <span className="font-semibold text-foreground">Contact form.</span> If you message us via
              our Contact page, we store your name, the email or contact detail you provide, and your
              message — solely to respond to you.
            </li>
            <li>
              <span className="font-semibold text-foreground">Booking details.</span> When you book a
              session, scheduling and payment are handled entirely by our booking partner, Cal.id. We do
              not receive or store your booking or payment information ourselves — please refer to Cal.id's
              own privacy policy for how they handle that data.
            </li>
            <li>
              <span className="font-semibold text-foreground">Basic usage analytics.</span> We use Firebase
              Analytics to understand how visitors use our website (e.g. which pages are viewed) — this
              does not include anything you say in a session or to your therapist.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">How we use this information</h2>
          <p className="mt-3">
            We use contact form submissions only to reply to your query. We use analytics only to
            understand and improve our website. We do not sell your information to anyone.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Your rights</h2>
          <p className="mt-3">
            You can ask us what information we hold about you, or ask us to delete it, at any time by
            writing to us — see Contact details below.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Contact</h2>
          <p className="mt-3">
            Questions about this policy or your data? Write to us at{" "}
            <a href="mailto:admin@eunoia.care" className="font-semibold text-accent underline-offset-4 hover:underline">
              admin@eunoia.care
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
